import { FinanceEngineV2 } from '../../components/FinanceEngineV2';

const FinanceEngineV2Screen = () => <FinanceEngineV2 />;

export { FinanceEngineV2Screen };
